export const en = {
  welcome: "Welcome to",
  limit: "Limit: ",
  exclusive: "Exclusive to:"
};
